<template>
  <div id="app" class="min-h-screen">
    <router-view></router-view>
    
    <!-- 登录弹框组件 -->
    <LoginDialog :visible="isLoggedDialogVisible" @close="handleLoginClose" />

    <!-- 注册弹框组件 -->
    <RegisterDialog :visible="isRegisterDialogVisible" @close="handleRegisterClose" />

    <!-- 用户邀请-注册弹框组件 -->
    <InviteRegisterDialog :visible="isInviteRegisterDialogVisible" @close="handleInviteRegisterClose" />

    <CommonDialog
    :title="this.$t('login.registerTitle')"
      :visible.sync="isNewRegister"
      :buttons="[
        { text: this.$t('common.confirm'), type: 'primary', action: 'cancel' },
      ]"
      @button-click="handleDialog"
      @close="handleDialog">
      <div class="text-center">
        <div class="mb-4">
          {{ $t("login.registerSuccess") }}{{ couponAmount }} {{ $t("login.registerSuccessDesc") }}
        </div>
      </div>
    </CommonDialog>

  </div>
</template>

<script>
import LoginDialog from "@/components/home/LoginDialog.vue"
import RegisterDialog from "@/components/home/RegisterDialog.vue"
import InviteRegisterDialog from "@/components/home/InviteRegisterDialog.vue"

import { mapGetters } from "vuex"
export default {
  name: 'App',
  data() {
    return {
      // loginDialogVisible: false,
    }
  },
  components: {
    LoginDialog,
    RegisterDialog,
    InviteRegisterDialog
  },
  computed: {
    ...mapGetters({
      isLoggedDialogVisible: "auth/isLoggedDialogVisible",
      isRegisterDialogVisible: "auth/isRegisterDialogVisible",
      isInviteRegisterDialogVisible: "auth/isInviteRegisterDialogVisible",
      isNewRegister: "auth/isNewRegister",
      couponAmount: "auth/couponAmount",
    }),
  },
  watch: {
    isNewRegister: {
      handler(newVal) {
        console.log('newVal :>> ', newVal);
      },
    },
  },
  methods: {
    handleLoginClose() {
      this.$store.commit("auth/SET_LOGIN_DIALOG_VISIBLE", false)
    },
    handleRegisterClose() {
      this.$store.commit("auth/SET_REGISTER_DIALOG_VISIBLE", false)
    },
    handleInviteRegisterClose() {
      this.$store.commit("auth/SET_INVITE_REGISTER_DIALOG_VISIBLE", false)
      // 去掉 URL 中的 inviteCode 参数（如果存在）
      if (this.$route.query.inviteCode) {
        const query = { ...this.$route.query }
        delete query.inviteCode
        // 检查去掉参数后路由是否真的变化
        if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
          this.$router.replace({ query }).catch(() => {})
        }
      }
    },
    handleDialog() {  
      this.$store.commit("auth/SET_IS_NEW_REGISTER", false)
    },
  },
  created() {
    setTimeout(() => {
      // this.loginDialogVisible = true
    }, 2000)
  }
}
</script>

<style scoped>
</style>


